import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import './index.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Grommet } from 'grommet';

import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from "@mui/material/styles";
import { BrowserRouter as Router } from 'react-router-dom';
import LoupeGdprWrapper from './components/LoupeGdprWrapper';

ReactDOM.render(

  <React.StrictMode>
    <Grommet plain>

      <Router basename={process.env.REACT_APP_FOLDER_NAME}>
        <StyledEngineProvider injectFirst>
          <CssBaseline /> 
            <LoupeGdprWrapper />
        </StyledEngineProvider>
      </Router>
  
    </Grommet>

  </React.StrictMode>,
  document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
